// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/checkbox/Disabled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Checkbox, view } from '@sail/ui';
export const Disabled = () => {
  const [checked, setChecked] = React.useState(false);
  return <view.div css={{
    layout: 'column'
  }}>
      <Checkbox label="This uncontrolled Checkbox is disabled." defaultChecked disabled />
      <Checkbox onChange={() => {
      setChecked(!checked);
    }} checked={checked} disabled label="This controlled Checkbox is disabled." />
      <Checkbox disabled invalid defaultChecked label="This uncontrolled, invalid Checkbox is disabled." />
    </view.div>;
};